import React from 'react'
import Link from 'gatsby-link'

//  Components
import ThemeLink from '../ThemeLink/ThemeLink.js'
import Button from '../Button/Button.js'

//  Styles
import styles from './KeyThemes.module.scss'

const KeyThemes = ( props ) => (
  <div>
    <div className={ styles.key__themes }>
      <h2 className={ styles.key__themes__title }>Highlights</h2>
      <ul className={ styles.key__themes__list }>
        { props.data.allThemesJson.edges.map((node) =>
          <li key={node.node.theme_id}>
            <ThemeLink 
            node={node.node}
            className="theme__link__large"/>
          </li>
        )}
      </ul>
    </div>
    <div className={ styles.key__themes__conclusion }>
      <h2><Link to="/conclusion">Conclusion</Link></h2>
      <div className={ styles.key__themes__conclusion__content }>
        <h3>States face important challenges in promoting affordable health care and the best possible outcomes for their residents.</h3>
        <p>The widespread gains in people’s coverage and access to health care following the ACA passage in 2010 have largely stalled since 2015, with even some ominous erosion from 2016 to 2017 in 16 states.  Stalled gains are attributable to lack of Medicaid expansion in 17 states, people with incomes just over the eligibility threshold for marketplace subsidies (about $48,560 for an individual) and many in employer plans have high premium costs; recent Congressional and executive actions on the individual market and Medicaid have reduced potential enrollment in both; and undocumented immigrants are ineligible for subsidized coverage.</p>
        <p>These stalled gains in coverage come at a time when health care spending continues to grow at a faster clip than median income,  translating into higher premium and out-of-pocket costs relative to income, for many families. Finally, in some states, people face shorter life expectancies than just a few years ago, thanks in part to unrelenting increases in deaths linked to suicide, alcohol, and drug overdose.</p>
        <Button
          to="/conclusion"
          text="Keep Reading"
          className="button__primary__reversed"
          />
      </div>
    </div>
  </div>
)

export default KeyThemes



// WEBPACK FOOTER //
// ./src/components/KeyThemes/KeyThemes.js